import { fetcher } from 'components/shared/fetcher.js'
import { QuotationRequest } from 'components/ordering/quotation/api/quotation-request.js'
import { baseUrl } from '@cloudsuite/mosaic-shared/scripts/base-url.js'


export const executeQuotationRequest = async <T, E>(request: QuotationRequest<T, E>): Promise<T | E> => {
  const url = new URL(request.path, await baseUrl())
  const response = await fetcher.fetch(url, request.init)
  const data: unknown = await parseDataFromResponse(response)

  if (response.ok) return request.parseResponse?.(data) as T

  return request.parseError(response.status, data) as E
}

const parseDataFromResponse = async (response: Response): Promise<unknown> => {
  // https://fetch.spec.whatwg.org/#statuses
  const nullBodyStatuses = [101, 103, 204, 205, 304]

  if (nullBodyStatuses.includes(response.status)) return null

  const text = await response.text()
  if (!text) return null
  return JSON.parse(text)
}
